import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { StdCard } from 'components'
import { columns } from '../../AttributeData'
import { numberFormat } from '../../helper'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { Container } from './styled'

const POItemInfo = props => {
  const {
    isCreate = false,
    isEdit = false,
    poSelect,
  } = props

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="PO Item Details">
          <Container>
            <div className='headerText'>{`${poSelect.vendorCode} | ${poSelect.vendorName}`}</div>
            <ReactTable 
              data={poSelect.items}
              columns={columns.tPOItem}
              defaultPageSize={10}
              noDataText="No Item found"
              previousText={<Icon name="arrow alternate circle left" />}
              nextText={<Icon name="arrow alternate circle right" />}
              className="-striped -highlight"
            />
            <div className='amountCont'>
              <span className='header'>
                Total Amount :
              </span>
              <span className='data'>
                {numberFormat(poSelect.totalAmount)}
                <span style={{marginLeft:'0.5rem'}}>{poSelect.currencyCode}</span>
              </span>
            </div>
            <div className='amountCont'>
              <span className='header'>
                Discount :
              </span>
              <span className='data'>
                {numberFormat(poSelect.discount)}
                <span style={{marginLeft:'0.5rem'}}>{poSelect.currencyCode}</span>
              </span>
            </div>
            <div className='amountCont'>
              <span className='header'>
                After Discount :
              </span>
              <span className='data'>
                {numberFormat(poSelect.afterDiscount)}
                <span style={{marginLeft:'0.5rem'}}>{poSelect.currencyCode}</span>
              </span>
            </div>
            <div className='amountCont'>
              <span className='header'>
                {`Vat Amount${poSelect.vatRate?`(${poSelect.vatRate}%)`:''} :`}
              </span>
              <span className='data'>
                {numberFormat(poSelect.vatAmount)}
                <span style={{marginLeft:'0.5rem'}}>{poSelect.currencyCode}</span>
              </span>
            </div>
            <div className='amountCont'>
              <span className='header'>
                Net Amount :
              </span>
              <span className='data'>
                {numberFormat(poSelect.netAmount)}
                <span style={{marginLeft:'0.5rem'}}>{poSelect.currencyCode}</span>
              </span>
            </div>
          </Container>
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = state => {
  let valueForm = getFormValues('formPOUpdate')(state)
  let poCompleteDetail = state.poUpdate.poCompleteDetail.data
  return {
    valueForm:valueForm||{},
    poSelect: poCompleteDetail
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(POItemInfo)
